module.exports = __webpack_public_path__ + "static/media/catalouge-16.0c772412.jpg";